import { Stack } from "@mui/material";
import React from "react";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { GoToConversation } from "../GoToConversation";
import { ViewLabeling } from "../ViewLabeling";
import { ViewTranscript } from "../ViewTranscript";

/** Links under a tested conversation. Synthetic calls have no conversation or labeling to open. */
export function ResultActions({
    result,
}: {
    result: TestLLMClassifierAgreementResult;
}) {
    return (
        <Stack direction="row" columnGap={1} alignSelf="flex-end">
            {!result.conversation.isSynthetic && (
                <>
                    <GoToConversation conversationId={result.conversation.id} />
                    <ViewLabeling conversation={result.conversation} />
                </>
            )}
            {result.executionResult?.transcript && (
                <ViewTranscript
                    transcript={result.executionResult.transcript}
                />
            )}
        </Stack>
    );
}
